module.exports = __webpack_public_path__ + "img/logo-bg.cc662079.png";